const $ = jQuery

const handlerComponent = () => {
  event.preventDefault()
  
  const that = event.target
  
  if( $(that).parent().hasClass('selected') )
  return false;
  
  $(that).parents('.display-box').find('span').not('.erase').toggleClass('selected');
  
  $('.list-wrapper').fadeToggle(400, function() {
    if( $('.activeSlide').length )
    return false;
  });
}

const doCycle = () => {
  $.each( $('.list .item'), function(i,v) {
    cl = $(this).attr('class').replace( /item/, '' ).trim();
    if( $(this).find('.gallery-img img').length > 0 ) {
      $(this).find('.gallery-img').cycle({
        pager: '.'+cl+' .gallery-nav'
      }).cycle('pause');
    }
  }).wraplist();
}

( () => {
  $('.display-box .mode').on('click', handlerComponent)
})()